export default {
  data: [
    {
      _id: "5f4770dc0d6c88901599aae7",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18246,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-05-14T00:00:00.000Z",
      type: "MEDICINE",
      resource_name: "Hydro Floc - EDTA",
      quantity: 1.5,
      v1_created_at: "2020-05-14T23:42:35.000Z",
      created_at: "2020-08-27T09:37:30.353Z",
      updated_at: "2020-08-27T09:37:30.353Z",
    },
    {
      _id: "5f4770dc0d6c88901599aadb",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18234,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-05-07T00:00:00.000Z",
      type: "MINERAL",
      resource_name: "HCL",
      quantity: 2,
      v1_created_at: "2020-05-10T08:04:05.000Z",
      created_at: "2020-08-27T09:37:30.352Z",
      updated_at: "2020-08-27T09:37:30.352Z",
    },
    {
      _id: "5f4770dc0d6c88901599aadf",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18238,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-05-07T00:00:00.000Z",
      type: "MINERAL",
      resource_name: "Aries",
      quantity: 20,
      v1_created_at: "2020-05-11T13:27:04.000Z",
      created_at: "2020-08-27T09:37:30.352Z",
      updated_at: "2020-08-27T09:37:30.352Z",
    },
    {
      _id: "5f4770dc0d6c88901599aae0",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18239,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-05-07T00:00:00.000Z",
      type: "MINERAL",
      resource_name: "MG C0MMERCIAL",
      quantity: 30,
      v1_created_at: "2020-05-11T13:27:29.000Z",
      created_at: "2020-08-27T09:37:30.352Z",
      updated_at: "2020-08-27T09:37:30.352Z",
    },
    {
      _id: "5f4770dc0d6c88901599aad6",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18229,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-05-06T00:00:00.000Z",
      type: "MEDICINE",
      resource_name: "Hydro Floc - EDTA",
      quantity: 2,
      v1_created_at: "2020-05-06T15:37:17.000Z",
      created_at: "2020-08-27T09:37:30.351Z",
      updated_at: "2020-08-27T09:37:30.351Z",
    },
    {
      _id: "5f4770dc0d6c88901599aad2",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18225,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-05-03T00:00:00.000Z",
      type: "MEDICINE",
      resource_name: "FreeTox",
      quantity: 2,
      v1_created_at: "2020-05-04T22:55:33.000Z",
      created_at: "2020-08-27T09:37:30.350Z",
      updated_at: "2020-08-27T09:37:30.350Z",
    },
    {
      _id: "5f4770dc0d6c88901599aace",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18221,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-05-02T00:00:00.000Z",
      type: "MINERAL",
      resource_name: "Potash",
      quantity: 30,
      v1_created_at: "2020-05-03T08:46:17.000Z",
      created_at: "2020-08-27T09:37:30.350Z",
      updated_at: "2020-08-27T09:37:30.350Z",
    },
    {
      _id: "5f4770dc0d6c88901599aaca",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18217,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-05-01T00:00:00.000Z",
      type: "MINERAL",
      resource_name: "MG C0MMERCIAL",
      quantity: 30,
      v1_created_at: "2020-05-02T05:44:28.000Z",
      created_at: "2020-08-27T09:37:30.350Z",
      updated_at: "2020-08-27T09:37:30.350Z",
    },
    {
      _id: "5f4770dc0d6c88901599aac6",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18212,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-04-30T00:00:00.000Z",
      type: "MINERAL",
      resource_name: "Aries",
      quantity: 15,
      v1_created_at: "2020-05-02T05:42:15.000Z",
      created_at: "2020-08-27T09:37:30.349Z",
      updated_at: "2020-08-27T09:37:30.349Z",
    },
    {
      _id: "5f4770dc0d6c88901599aabe",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18204,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-04-29T00:00:00.000Z",
      type: "MEDICINE",
      resource_name: "D-Flow",
      quantity: 5,
      v1_created_at: "2020-04-29T11:37:50.000Z",
      created_at: "2020-08-27T09:37:30.349Z",
      updated_at: "2020-08-27T09:37:30.349Z",
    },
    {
      _id: "5f4770dc0d6c88901599aac2",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18208,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-04-27T00:00:00.000Z",
      type: "MINERAL",
      resource_name: "HCL",
      quantity: 2,
      v1_created_at: "2020-04-29T12:46:49.000Z",
      created_at: "2020-08-27T09:37:30.349Z",
      updated_at: "2020-08-27T09:37:30.349Z",
    },
    {
      _id: "5f4770dc0d6c88901599aab4",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18194,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-04-24T00:00:00.000Z",
      type: "MINERAL",
      resource_name: "MG C0MMERCIAL",
      quantity: 30,
      v1_created_at: "2020-04-25T14:34:28.000Z",
      created_at: "2020-08-27T09:37:30.348Z",
      updated_at: "2020-08-27T09:37:30.348Z",
    },
    {
      _id: "5f4770dc0d6c88901599aaab",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18187,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-04-23T00:00:00.000Z",
      type: "MINERAL",
      resource_name: "MG C0MMERCIAL",
      quantity: 40,
      v1_created_at: "2020-04-23T10:19:38.000Z",
      created_at: "2020-08-27T09:37:30.348Z",
      updated_at: "2020-08-27T09:37:30.348Z",
    },
    {
      _id: "5f4770dc0d6c88901599aaa6",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18183,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-04-19T00:00:00.000Z",
      type: "MEDICINE",
      resource_name: "FreeTox",
      quantity: 2,
      v1_created_at: "2020-04-21T14:43:14.000Z",
      created_at: "2020-08-27T09:37:30.347Z",
      updated_at: "2020-08-27T09:37:30.347Z",
    },
    {
      _id: "5f4770dc0d6c88901599aa94",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18169,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-04-16T00:00:00.000Z",
      type: "MINERAL",
      resource_name: "MG C0MMERCIAL",
      quantity: 30,
      v1_created_at: "2020-04-17T06:05:15.000Z",
      created_at: "2020-08-27T09:37:30.346Z",
      updated_at: "2020-08-27T09:37:30.346Z",
    },
    {
      _id: "5f4770dc0d6c88901599aa8f",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18164,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-04-14T00:00:00.000Z",
      type: "MINERAL",
      resource_name: "Potash",
      quantity: 30,
      v1_created_at: "2020-04-14T10:11:50.000Z",
      created_at: "2020-08-27T09:37:30.346Z",
      updated_at: "2020-08-27T09:37:30.346Z",
    },
    {
      _id: "5f4770dc0d6c88901599aa8b",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18160,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-04-09T00:00:00.000Z",
      type: "MINERAL",
      resource_name: "MG C0MMERCIAL",
      quantity: 30,
      v1_created_at: "2020-04-10T08:16:19.000Z",
      created_at: "2020-08-27T09:37:30.345Z",
      updated_at: "2020-08-27T09:37:30.345Z",
    },
    {
      _id: "5f4770dc0d6c88901599aa73",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18136,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-04-06T00:00:00.000Z",
      type: "MINERAL",
      resource_name: "Potash",
      quantity: 30,
      v1_created_at: "2020-04-07T01:01:00.000Z",
      created_at: "2020-08-27T09:37:30.343Z",
      updated_at: "2020-08-27T09:37:30.343Z",
    },
    {
      _id: "5f4770dc0d6c88901599aa6b",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18128,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-04-04T00:00:00.000Z",
      type: "MINERAL",
      resource_name: "MG Max",
      quantity: 15,
      v1_created_at: "2020-04-05T02:19:41.000Z",
      created_at: "2020-08-27T09:37:30.343Z",
      updated_at: "2020-08-27T09:37:30.343Z",
    },
    {
      _id: "5f4770dc0d6c88901599aa7b",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18144,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-04-04T00:00:00.000Z",
      type: "PRO_BIOTIC",
      resource_name: "EM",
      quantity: 0.5,
      v1_created_at: "2020-04-08T01:33:31.000Z",
      created_at: "2020-08-27T09:37:30.344Z",
      updated_at: "2020-08-27T09:37:30.344Z",
    },
    {
      _id: "5f4770dc0d6c88901599aa51",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18102,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-03-30T00:00:00.000Z",
      type: "MINERAL",
      resource_name: "Aries",
      quantity: 15,
      v1_created_at: "2020-03-30T03:11:47.000Z",
      created_at: "2020-08-27T09:37:30.339Z",
      updated_at: "2020-08-27T09:37:30.339Z",
    },
    {
      _id: "5f4770dc0d6c88901599aa38",
      user_id: "5e1897b5188b23258b3465c3",
      v1_id: 18077,
      pond_id: "5e1897b5188b23258b347744",
      v1_pond_id: 1856,
      date: "2020-03-26T00:00:00.000Z",
      type: "MINERAL",
      resource_name: "Potash",
      quantity: 20,
      v1_created_at: "2020-03-26T13:35:17.000Z",
      created_at: "2020-08-27T09:37:30.335Z",
      updated_at: "2020-08-27T09:37:30.335Z",
    },
  ],
  data1:
    '{"message":"Ponds with errors fetched successfully.","success":true,"total_devices":{"pond_mothers":413,"pond_guards":19,"shrimp_talks":205},"ponds":[{"_id":"5e1897b5188b23258b347513","title":"Ps 40","location_id":"5e6b72ca5dbdfd49d7b7df22","user_id":"5e1897b5188b23258b3464ae","cultivation_date":"2020-07-08T00:00:00.000Z","timezone":{"name":"America/Guayaquil","offset":-300},"pond_mother_alerts":[{"device_code":"A18E36","device_id":"5e19603ecef2955034c8b269","device_title":"Ps 40-03","device_type":"POND_MOTHER","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-07-13T15:29:58.000Z","updated_date":"2020-07-13T15:29:58.000Z","details":{}},{"count":1,"error_code":"NO_SCHEDULES","status":"UNRESOLVED","start_date":"2020-07-13T15:29:58.000Z","updated_date":"2020-07-13T15:29:58.000Z","details":{}}]},{"device_code":"A18C7E","device_id":"5e19603ecef2955034c8b2a0","device_title":"Ps 40-06","device_type":"POND_MOTHER","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-03T12:51:19.000Z","updated_date":"2020-08-03T12:51:19.000Z","details":{}},{"count":1,"error_code":"NO_SCHEDULES","status":"UNRESOLVED","start_date":"2020-08-03T12:51:19.000Z","updated_date":"2020-08-03T12:51:19.000Z","details":{}}]},{"device_code":"A18B86","device_id":"5e19603ecef2955034c8b2b7","device_title":"Ps 40-01","device_type":"POND_MOTHER","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-11T05:07:24.000Z","updated_date":"2020-08-11T05:07:24.000Z","details":{}},{"count":1,"error_code":"NO_SCHEDULES","status":"UNRESOLVED","start_date":"2020-08-11T05:07:24.000Z","updated_date":"2020-08-11T05:07:24.000Z","details":{}}]},{"device_code":"A187CE","device_id":"5e19603ecef2955034c8b32e","device_title":"Ps 40-12","device_type":"POND_MOTHER","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-03T12:50:47.000Z","updated_date":"2020-08-03T12:50:47.000Z","details":{}},{"count":1,"error_code":"NO_SCHEDULES","status":"UNRESOLVED","start_date":"2020-08-03T12:50:47.000Z","updated_date":"2020-08-03T12:50:47.000Z","details":{}}]},{"device_code":"A1F05E","device_id":"5e19603ecef2955034c8b21c","device_title":"Ps 40-13","device_type":"POND_MOTHER","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-11T04:51:12.000Z","updated_date":"2020-08-11T04:51:12.000Z","details":{}},{"count":1,"error_code":"NO_SCHEDULES","status":"UNRESOLVED","start_date":"2020-08-11T04:51:12.000Z","updated_date":"2020-08-11T04:51:12.000Z","details":{}}]},{"device_code":"A1FCAE","device_id":"5e19603ecef2955034c8b096","device_title":"Ps 40-05","device_type":"POND_MOTHER","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-03T12:51:23.000Z","updated_date":"2020-08-03T12:51:23.000Z","details":{}},{"count":1,"error_code":"NO_SCHEDULES","status":"UNRESOLVED","start_date":"2020-08-03T12:51:23.000Z","updated_date":"2020-08-03T12:51:23.000Z","details":{}}]},{"device_code":"A18FCE","device_id":"5e19603ecef2955034c8b22e","device_title":"Ps 40-08","device_type":"POND_MOTHER","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-11T04:38:16.000Z","updated_date":"2020-08-11T04:38:16.000Z","details":{}},{"count":1,"error_code":"NO_SCHEDULES","status":"UNRESOLVED","start_date":"2020-08-11T04:38:16.000Z","updated_date":"2020-08-11T04:38:16.000Z","details":{}}]},{"device_code":"A1D97E","device_id":"5e19603ecef2955034c8ace6","device_title":"Ps 40-07","device_type":"POND_MOTHER","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-11T05:06:30.000Z","updated_date":"2020-08-11T05:06:30.000Z","details":{}},{"count":1,"error_code":"NO_SCHEDULES","status":"UNRESOLVED","start_date":"2020-08-11T05:06:30.000Z","updated_date":"2020-08-11T05:06:30.000Z","details":{}}]},{"device_code":"A18F76","device_id":"5e19603ecef2955034c8b241","device_title":"Ps 40-09","device_type":"POND_MOTHER","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-11T04:34:08.000Z","updated_date":"2020-08-11T04:34:08.000Z","details":{}},{"count":1,"error_code":"NO_SCHEDULES","status":"UNRESOLVED","start_date":"2020-08-11T04:34:08.000Z","updated_date":"2020-08-11T04:34:08.000Z","details":{}}]},{"device_code":"A18806","device_id":"5e19603ecef2955034c8b327","device_title":"Ps 40-14","device_type":"POND_MOTHER","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-11T05:06:24.000Z","updated_date":"2020-08-11T05:06:24.000Z","details":{}},{"count":1,"error_code":"NO_SCHEDULES","status":"UNRESOLVED","start_date":"2020-08-11T05:06:24.000Z","updated_date":"2020-08-11T05:06:24.000Z","details":{}}]},{"device_code":"A18DD6","device_id":"5e19603ecef2955034c8b26d","device_title":"Ps 40-15","device_type":"POND_MOTHER","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-03T13:10:18.000Z","updated_date":"2020-08-03T13:10:18.000Z","details":{}},{"count":1,"error_code":"NO_SCHEDULES","status":"UNRESOLVED","start_date":"2020-08-03T13:10:18.000Z","updated_date":"2020-08-03T13:10:18.000Z","details":{}}]},{"device_code":"A18CAE","device_id":"5e19603ecef2955034c8b29a","device_title":"Ps 40-02","device_type":"POND_MOTHER","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-03T13:15:24.000Z","updated_date":"2020-08-03T13:15:24.000Z","details":{}},{"count":1,"error_code":"NO_SCHEDULES","status":"UNRESOLVED","start_date":"2020-08-03T13:15:24.000Z","updated_date":"2020-08-03T13:15:24.000Z","details":{}}]},{"device_code":"A18BCE","device_id":"5e19603ecef2955034c8b2ae","device_title":"Ps 40-04","device_type":"POND_MOTHER","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-11T05:05:23.000Z","updated_date":"2020-08-11T05:05:23.000Z","details":{}},{"count":1,"error_code":"NO_SCHEDULES","status":"UNRESOLVED","start_date":"2020-08-11T05:05:23.000Z","updated_date":"2020-08-11T05:05:23.000Z","details":{}}]},{"device_code":"A18DDE","device_id":"5e19603ecef2955034c8b26c","device_title":"Ps 40-10","device_type":"POND_MOTHER","errors_data":[{"count":1,"error_code":"NO_SCHEDULES","status":"UNRESOLVED","start_date":"2020-09-01T09:33:21.000Z","updated_date":"2020-09-01T09:33:21.000Z","details":{}}]},{"device_code":"A18BA6","device_id":"5e19603ecef2955034c8b2bb","device_title":"Ps 40-11","device_type":"POND_MOTHER","errors_data":[{"count":1,"error_code":"NO_SCHEDULES","status":"UNRESOLVED","start_date":"2020-09-01T09:33:25.000Z","updated_date":"2020-09-01T09:33:25.000Z","details":{}}]}],"pond_guard_alerts":[{"device_code":"A1E15E","device_id":"5e284d1941455e31d228d562","device_title":"A1E15E","device_type":"POND_GUARD","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-11T05:10:10.000Z","updated_date":"2020-08-11T05:10:10.000Z","details":{}}]}],"shrimp_talk_alerts":[{"device_code":"A817AE","device_id":"5e63b0bd675b27bbc371d4ca","device_title":"ST80654","device_type":"SHRIMP_TALK","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-26T04:59:52.000Z","updated_date":"2020-08-26T04:59:52.000Z","details":{}}]},{"device_code":"A82C46","device_id":"5e63b0bd675b27bbc371d667","device_title":"ST81011","device_type":"SHRIMP_TALK","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-28T04:55:17.000Z","updated_date":"2020-08-28T04:55:17.000Z","details":{}}]},{"device_code":"A82C16","device_id":"5e63b0bd675b27bbc371d66e","device_title":"ST81017","device_type":"SHRIMP_TALK","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-28T04:58:00.000Z","updated_date":"2020-08-28T04:58:00.000Z","details":{}}]},{"device_code":"A82B0E","device_id":"5e63b0bd675b27bbc371d691","device_title":"ST81050","device_type":"SHRIMP_TALK","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-28T04:59:12.000Z","updated_date":"2020-08-28T04:59:12.000Z","details":{}}]},{"device_code":"A82A36","device_id":"5e63b0bd675b27bbc371d6b9","device_title":"ST81085","device_type":"SHRIMP_TALK","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-28T04:59:29.000Z","updated_date":"2020-08-28T04:59:29.000Z","details":{}}]},{"device_code":"A829A6","device_id":"5e6b17573408bd9112bcc41e","device_title":"ST81103","device_type":"SHRIMP_TALK","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-27T11:28:20.006Z","updated_date":"2020-08-27T11:28:20.006Z","details":{}}]},{"device_code":"A8272E","device_id":"5e7848af3408bd9112b3c196","device_title":"ST81182","device_type":"SHRIMP_TALK","errors_data":[{"count":1,"error_code":"NO_COMMUNICATION","status":"UNRESOLVED","start_date":"2020-08-27T06:15:50.532Z","updated_date":"2020-08-27T06:15:50.532Z","details":{}}]}]}]}',
};
